module.exports = __webpack_public_path__ + "img/loginLogo1.c353efb8.png";